import * as React from "react";
import { theme } from "../../theme/theme";
import { Typography, List, ListItem, ListItemText } from "@material-ui/core";

import DynamicIcon from "../Icons/DynamicIcon";

import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { styles } from "./ListIcon.style";

// TODO: @bm - set up type properly
type ListItem = {
    icon: string;
    text: string
};

interface ListProps {
    list: ListItem[];
}

class ListIcon extends React.Component<ListProps & WithStyles<typeof styles>> {

    public render() {

        const classes = this.props.classes;

        return (
            <>
                <List className={classes.list}>
                {this.props.list.map(item =>
                    <ListItem className={classes.item} key={item.icon} disableGutters={true}>
                        <DynamicIcon name={item.icon} nativeColor={theme.palette.primary.main} />
                        <ListItemText 
                            primary={<Typography dangerouslySetInnerHTML={{ __html: item.text }} />}
                        />
                    </ListItem>
                )}
                </List>
            </>
        );
    }

}

export default withStyles(styles)(ListIcon);


// WEBPACK FOOTER //
// ./src/components/ListIcon/ListIcon.tsx